import { SVG } from "@svgdotjs/svg.js";
import { resolveDancer } from "./dancer.js";
import { geometrize } from "./geometry.js";
import { defaultOptions, resolveOptions, } from "./options.js";
import { parse } from "./parser.js";
import { Renderer } from "./renderer.js";
export class Formation {
    dancers;
    options;
    constructor(input, options) {
        this.options = options ? resolveOptions(options) : defaultOptions;
        const { layout: { geometry, origin }, } = this.options;
        const dancers = typeof input === "string" ? parse(input) : input;
        this.dancers = dancers.flatMap((dancer) => geometrize(resolveDancer(dancer), geometry, origin));
    }
    drawDancers(renderer) {
        this.dancers.forEach((dancer) => renderer.drawDancer(dancer));
        renderer.resizeImage();
    }
    toElement(element) {
        this.drawDancers(new Renderer(this.options, SVG(element)));
    }
    toString(element) {
        const render = new Renderer(this.options, element ? SVG(element) : SVG());
        this.drawDancers(render);
        return render.draw.svg();
    }
}
export function formationToSvg(input, options) {
    return new Formation(input, options).toString();
}
//# sourceMappingURL=formation.js.map